module.exports = __webpack_public_path__ + "img/home_menu_12_default.38d18132.png";